function AltSuspicious() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Alternative text is present for an image that is within a link.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Including appropriate alternative text on an image within a link ensures that the function and purpose of the link and the content of the image is available to screen reader users or when images are unavailable.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that the alternative text presents the content of the image and/or the function of the link. If the full content and function of the link is presented in text within the link (an image and a text caption both within the same link, for example), then the image should generally be given empty/null alternative text (alt="") to avoid redundancy.</p>
    </blockquote>
  )
}

export default AltSuspicious